import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomButton from '../CustomButton'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'
import Banner from './Banner'
import { useNavigate } from 'react-router-dom'


const Services = ({data}) => {


  const [activeId, setActiveId] = useState(1);
  
  const handleClick = (id) => {
    setActiveId(id);
    console.log("Clicked Submenu ID:", id);
  };

  return (
    <div className='service'>
        <Header mode={data.mode} />
    {/* Banner */}
    <Banner 
    mode={data.mode}
    bannerImg={data.bannerImg}
    title={data.service_name}
    main_content={data.main_content}
    />

     {/* About */}
    <div className="service-info volto-section page-type-secvies">
    <Container className="" >
    <SectionHeader mainText1={data.service_name}  />
      <Row>
        <Col lg={6}>
         
          <SectionSubHeader headerText={data.title} />
         
        </Col>
        <Col lg={6} className='text-justify'> 
        <p>{data.content1}</p>
        <p>{data.content2}</p>
        </Col>
      </Row>
    </Container>
     
  </div>
  {/* submenu list */}
  <div className='service-submenu  volto-section'>
    <Container>
    <div className='service-buttopn-row'>
    {data.submenu?.map((submenuItem) => (
       
        <button className={activeId === submenuItem.id ? "active" : ""}  key={submenuItem.id} onClick={() => handleClick(submenuItem.id)}>
         {submenuItem.name}
       </button>
      
     ))}   
     </div>
     {data.submenu?.map((submenuItem) => (
        <div className={activeId === submenuItem.id ? "show" : ""} style={{display: 'none'}}>
        <Row key={submenuItem.id} className="submenu" style={{rowGap: '30px'}}>
            <Col lg={8}>
              <SectionSubHeader headerText={submenuItem.name} />
              <p>{submenuItem.content}</p>
            </Col>
            <Col lg={6}>
              <div className="card-list">
               {submenuItem.cardList.map((card, index) => (
                 <div key={index} className="card">
                  <h4>{card.title}</h4>
                  <p>{card.content}</p>
                 </div>
               ))}
              </div>
            </Col>
            <Col lg={6}>
             <div className="tab-list">
              {submenuItem.tabList.map((tab, index) => (
                <div key={index} className="tab">
                 <h4>{tab.icon && <img src={tab.icon} alt="Icon" />} {tab.title}</h4>
                 <p>{tab.content}</p>
                </div>
               ))}
             </div>
            </Col>
        </Row>
        </div>
     ))}
     
  
    </Container>
  </div>
  <Footer />
   </div>
  )
}

export default Services;
